import React from 'react';
import { getIntl } from '../../../../utils/intl';
import useFastenSandboxMode from '../../../../hooks/useFastenSandboxMode';
import Stack, { contentStackSpacing } from '../../../v2BaseComponents/Stack';
import { Switch } from '../../../v2BaseComponents/Inputs';
import Text from '../../../v2BaseComponents/Text';

const intl = getIntl('fasten-sandbox-mode-toggle', {
    header: 'Fasten sandbox mode',
    toggle: 'Connect new portals with Fasten test-mode credentials',
    description:
        'Development only. Sandbox connections reach FooClinic and vendor sandboxes instead of real portals and are marked "Sandbox".',
});

export type FastenSandboxModeToggleOwnProps = {};

export type FastenSandboxModeToggleProps = FastenSandboxModeToggleOwnProps;

const FastenSandboxModeToggle: React.FC<FastenSandboxModeToggleProps> = () => {
    const { canUseSandboxMode, isSandboxMode, setIsSandboxMode } = useFastenSandboxMode();
    if (!canUseSandboxMode) return null;
    return (
        <Stack vertical space={contentStackSpacing} style={{ alignSelf: 'stretch' }} align="flex-start">
            <Text variant="h5">{intl('header')}</Text>
            <Switch
                title={intl('toggle')}
                value={isSandboxMode}
                onChange={setIsSandboxMode}
                testID="fasten-sandbox-mode-toggle"
            />
            <Text variant="body-1" color="Gray-Text">
                {intl('description')}
            </Text>
        </Stack>
    );
};

export default React.memo(FastenSandboxModeToggle);
